import React from 'react'
import Demomiddlepage from './Demomiddlepage/Demomiddlepage';
import Demopagefooter from './Demofooterpage/Demopagefooter';
import Demotoppage from './Demotoppage/Demotoppage';

const Demopage = () => {
  return (
    <div>
    <Demotoppage />
    <Demomiddlepage />
    <Demopagefooter />
    </div>
  )
}

export default Demopage;